import InertiaRootLayout from "@/layouts/InertiaRootLayout"

/**
 * Shared `createInertiaApp` options for browser and SSR entrypoints.
 * Keep `pages` inline in each entrypoint — `@inertiajs/vite` rewrites via AST.
 */
export const inertiaAppConfig = {
  layout: () => InertiaRootLayout,
  strictMode: true,
}
